<template>
  <modal-component v-if="showModal && !isLoading" @close="close()" :container-style="'width:90%'">
    <div slot="header">
      <h3>{{ checkin.plan.client.first_name }} {{ checkin.plan.client.last_name }}: {{ checkin.form.name }}</h3>
    </div>
    <div slot="body">
      <div class="row">
        <div class="col-md mb-2">
          <!-- <h2>Submission <small>(Submitted {{ checkin.completed_at | moment('calendar')}})</small></h2> -->
          <h5>Program: {{ checkin.plan.program.name }} (Month {{ checkin.plan.plan_index }})</h5>
          <h5>Plan: <a :href="'/coach/plans/'+checkin.plan.id">{{ checkin.plan.name }}</a></h5>
          <h5>Check-in Submitted: {{ checkin.completed_at | moment("M/DD/YYYY hh:mm a") }}</h5>
          <div class="card">
            <div class="card-header">
              <h5 v-if="checkin.plan.data.fitness_goal">Goal: {{ convertFormSchemaAndDataForDisplay(checkin.plan.form.schema, checkin.plan.data).filter(function(a){return a.name=='fitness_goal';})[0].value }}</h5>
              <h5 v-if="checkin.form_data.weight">Weight: {{ checkin.form_data.weight }} {{ checkin.form_data.weight_units }} (Starting: {{ checkin.plan.data.weight }} {{ checkin.plan.data.weight_units }})</h5>
              <!-- <v-runtime-template
                v-if="checkin.form.description"
                :template="`<div>${checkin.form.description}</div>`"
                class="mx-1 text-left"
                ></v-runtime-template> -->
            </div>
            <div class="card-body">
              <div class="form">
                <div class="mb-1" v-for="(field, index) in convertFormSchemaAndDataForDisplay(checkin.form.schema, checkin.form_data)" v-bind:key="index">
                  <div v-if="field.type=='image'">
                    <strong>{{ field.label }}</strong><br />
                    <img v-if="field.value" :src="field.value" class="ml-2" style="max-width: 150px; max-height: 150px;">
                    <span v-else class="text-muted ml-2">N/A</span>
                  </div>
                  <div v-else>
                    <strong>{{ field.label }}</strong><br />
                    <span v-if="field.value" class="ml-2">{{ field.value }}</span>
                    <span v-else class="text-muted ml-2">N/A</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="h-100">
            <h2>Coach's Feedback</h2>
            <div class="feedback-wrapper d-flex justify-content-center">
              <template v-if="isLoading">
                <div class="text-center align-self-center">
                  <div class="spinner-border" style="width: 5rem; height: 5rem;" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <textarea
                  class="form-control h-100"
                  placeholder="Hey, great job this week..."
                  id="feedback-body"
                  required
                  v-model="feedbackBody"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template slot="footer">
      <button class="btn btn-default mr-auto" @click="close()" :disabled="isLoading">Cancel</button>
      <template v-if="isReviewed">
        <div class="alert alert-warning">
          Reviewed by {{ checkin.reviewed_by.nickname }} on {{ checkin.reviewed_at | moment("M/DD/YYYY hh:mm a") }}
        </div>
      </template>
      <template v-else>
        <button class="btn btn-danger" @click="markReviewed()" :disabled="!canMarkReviewed"><i class="mdi mdi-thumb-down"></i> No feedback required <i v-if="isMarkingReviewed" class="spinner-border" style="width: 1em; height: 1em; margin: 0 0 4px 4px"></i></button>
        <button class="btn btn-primary" @click="sendFeedback()" :disabled="!canSubmitFeedback"><i class="mdi mdi-message"></i> Send Feedback <i v-if="isSendingFeedback" class="spinner-border" style="width: 1em; height: 1em; margin: 0 0 4px 4px"></i></button>
      </template>
    </template>
  </modal-component>
</template>
<script>
import VRuntimeTemplate from "v-runtime-template";
import CheckinService from '@coach/js/services/CheckinService'
import {extractErrorMessage} from '@coach/js/utils/helpers'
export default {
  props: [
    'show',
    'checkin_id',
  ],
  components: {
    VRuntimeTemplate,
  },
  data() {
    return {
      checkin: {},
      showModal: !!this.show,
      feedbackBody: '',
      isLoading: true,
      isSendingFeedback: false,
      isMarkingReviewed: false,
    }
  },
  mounted() {
    // this.init();
  },
  computed: {
    canSubmitFeedback: function() {
      return !this.isLoading && !this.isSendingFeedback && this.isPendingReview && this.feedbackBody.length >= 50;
    },
    canMarkReviewed: function() {
      return !this.isLoading && !this.isMarkingReviewed && this.isPendingReview && this.feedbackBody.length == 0;
    },
    isPendingReview: function() {
      return this.checkin.status == 'pending_review';
    },
    isReviewed: function() {
      return this.checkin.status == 'reviewed';
    }
  },
  methods: {
    close: function() {
      this.showModal = false;
      this.$emit('close');
    },
    checkinUpdated: function(updatedCheckin) {
      this.showModal = false;
      this.$emit('checkinUpdated', updatedCheckin);
    },
    convertFormSchemaAndDataForDisplay: function (formSchema, formData) {
      let _this = this;
      // let formData = checkin.form_data;
      if (!formData.weight_units) {
        formData.weight_units = this.checkin.plan.client.weight_units;
      }
      let fields_to_display = [];
      _.forEach(formSchema, function(field, idx) {
        if (typeof field.visible == "string" && field.visible.indexOf('function') >= 0) {
          // .. do the conversion from string to function to bool
          // console.log("Converting visible field to function: " + field.name + " " + field.visible);
          field.visible = eval(field.visible);
          // field.visible=field.visible.call(this, _this.$root);
          field.visible=field.visible.call(this, formData);
        }
        // if (typeof field.required == "string" && field.required.indexOf('function') >= 0) {
        //     // .. do the convertion from string to bool
        //     // console.log("Converting required field to function: " + field.name + " " + field.visible);
        //     field.required = eval(field.required);
        // }
        if (field.visible !== false) {
          // console.log("visible: " + field.name);
          // add value. Show option label if that makes sense.
          field.value = formData?.[field.name];
          if (field.values && field.value) {
            field.value = field.values.find(function(val){ return val.value == field.value || val.id==field.value})?.name;
            // console.log("Mapping Value: " + field.name + " to " + field.value);
          }
          // console.log(field);
          fields_to_display.push(field);
        }
      });
      return fields_to_display;
    },
    init: function() {
      this.isLoading = true;
      this.loadData();
      // this.loadDefaultFeedback();
    },
    loadData: function() {
      CheckinService.getCheckin(this.checkin_id, 'include=form,latestFormSubmission,coachingProgramCheckin,reviewedBy,plan.client,plan.program,plan.form')
        .then((res) => {
          this.checkin = res.data.data;
          // this.isLoading = false;
          this.loadDefaultFeedback()
        })
        .catch(error => {
          // console.log(error)
          this.errorBag = error.data;
          this.isLoading = false;
        });
    },
    loadDefaultFeedback: function () {
      // console.log("Loading DefaultFeedback");
      if (!this.checkin?.id) {
        this.isLoading = false;
        return;
      }
      if (this.checkin.feedback_message) {
        this.feedbackBody = this.checkin.feedback_message;
        this.isLoading = false;
        return;
      }
      CheckinService.previewFeedback(this.checkin.id)
        .then(response => {
          this.feedbackBody = response.data.data.text;
          this.isLoading = false;
        })
        .catch(error => {
          // console.log(extractErrorMessage(error));
          // this.$toasted.error(extractErrorMessage(error));
          this.isLoading = false;
        });
    },
    markReviewed: function() {
      var _this = this;
      _this.isMarkingReviewed = true;
      CheckinService.markReviewed(_this.checkin.id)
        .then(response => {
          _this.$toasted.success("Checkin Marked reviewed!")
          _this.checkinUpdated(response.data.data);
        })
        .catch(error => {
          console.log(error.data ? error.data.message : error);
          _this.$toasted.error(error.data ? error.data.message : error);
        }).finally(function(){
          _this.isMarkingReviewed = false;
        });
    },
    sendFeedback: function() {
      var _this = this;
      this.isSendingFeedback = true;
      return CheckinService.sendFeedback(this.checkin.id, this.feedbackBody)
        .then(response => {
          _this.checkinUpdated(response.data.data);
          _this.$toasted.success("Feedback sent!");
        })
        .catch(error => {
          console.log(error.data ? error.data.message : error);
          _this.$toasted.error(error.data ? error.data.message : error);
        }).finally(function(){
          _this.isSendingFeedback = false;
        });
    },
  },
  watch: {
    show: function (newVal, oldVal) {
      Vue.set(this, 'showModal', newVal);
      if (this.showModal == true) {
        this.init();
      } else {
        this.checkin={};
        this.feedbackBody='';
      }
    }
  }
}
</script>
<style>
  .modal-body {
    margin: 10px 0 !important;
  }
</style>
